
import component from './componentBinding'
import slot from './slotBinding'
export var bindings = { component, slot }
